import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function CoinsAddPlus({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M8 18C5.239 18 3 17.1 3 16V8M3 8C3 7.46957 3.52678 6.96086 4.46447 6.58579C5.40215 6.21071 6.67392 6 8 6C9.32608 6 10.5979 6.21071 11.5355 6.58579C12.4732 6.96086 13 7.46957 13 8M3 8C3 8.53043 3.52678 9.03914 4.46447 9.41421C5.40215 9.78929 6.67392 10 8 10C9.32608 10 10.5979 9.78929 11.5355 9.41421C12.4732 9.03914 13 8.53043 13 8M11 15C11 16.1 13.23 17 16 17C18.76 17 21 16.1 21 15M11 15V19C11 20.1 13.23 21 16 21C18.76 21 21 20.1 21 19V15M11 15C11 13.89 13.23 13 16 13C18.76 13 21 13.89 21 15M13 8V10.5M17 5H21M19 7V3M8 14C5.239 14 3 13.1 3 12" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default CoinsAddPlus;